module.exports = __webpack_public_path__ + "public/images/dogs.467abe29ae3ee35d1795b041c7ae4a49.jpg";